import { combineReducers } from 'redux';
import appointmentReducer from './appointment/reducers/appointmentReducer';
import authReducer from './auth/reducers/authReducer';
import { forgotPasswordReducer } from './auth/reducers/forgotPasswordReducer';
import { resetPasswordReducer } from './auth/reducers/resetPasswordReducer';
import { guestCardReducer } from './guestCard/reducer/guestCardReducer';
import locationReducer from './location/reducers/locationReducers';
import store from './store';
import stripeReducer from './stripe/reducers/stripeReducer';
import tourReducer from './tour/reducers/tourReducer';
import unitReducer from './unit/reducers/unitReducer';
import unitsByLocationIdReducer from './unit/reducers/unitsByLocationIdReducer';
import { AnyIfEmpty } from 'react-redux';
import { verifyUserReducer } from './verify-user/reducer/verifyUserReducer';
import { leadSourceReducer } from './lead-sources/reducer/leadSourcesReducer';
import { changePasswordReducer } from './auth/reducers/changePasswordReducer';
import { editProfileReducer } from './auth/reducers/editProfileReducer';
import amenitiesReducer from './amenities/reducers/amenities.reducer';
import { locationListReducer } from './auth/reducers/locations.reducers';
import vendorVisitReducer from './vendorVisit/reducers/vendorVisit.reducer';
import vendorAppointmentsReducer from './vendorAppointments/reducers/vendorAppointmentsReducer';
import keyPickupDropReducer from './keyPickupDropEventVisit/reducers/keyPickupDropEventVisit.reducer';
import keyPickupDropEventReducer from './keyPickupDropEvents/reducers/keyPickupDropEvents.Reducer';

const appReducer = combineReducers({
    authReducer: authReducer,
    locationReducer: locationReducer,
    unitReducer: unitReducer,
    appointmentReducer: appointmentReducer,
    stripeReducer: stripeReducer,
    unitsByLocationId: unitsByLocationIdReducer,
    userTour: tourReducer,
    forgotPassword: forgotPasswordReducer,
    resetPassword: resetPasswordReducer,
    guestCard: guestCardReducer,
    verifyUser: verifyUserReducer,
    leadSourceReducer: leadSourceReducer,
    changePasswordReducer: changePasswordReducer,
    editProfileReducer: editProfileReducer,
    amenitiesReducer: amenitiesReducer,
    locationListReducer: locationListReducer,
    vendorVisitReducer: vendorVisitReducer,
    vendorAppointmentsReducer: vendorAppointmentsReducer,
    keyPickupDropReducer: keyPickupDropReducer,
    keyPickupDropEventReducer: keyPickupDropEventReducer,
});

const rootReducer = (state: AnyIfEmpty<object>, action: AnyIfEmpty<object>) => {
    if (action.type === 'LOGOUT') {
        state = undefined;
    }
    return appReducer(state, action);
};

export const logout = () => {
    return {
        type: 'LOGOUT',
    };
};
export default rootReducer;

export type IRootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;
